import BackButton from "../../atoms/BackButton";

function Footer({ backButton, children }) {
    return (
        <footer className="main-container">
            <div className="left-section">
                {
                    backButton && <BackButton />
                }
            </div>
            <div className="right-section">
                {
                    children
                }
            </div>
        </footer>
    );
}

export default Footer;